import FormattedMessage from 'I18n/components/FormattedMessage';
import { getCreditCountForAction, getCreditCountPerAction } from 'policy-lib';
import { useEnrichmentCredits } from '../EnrichmentCreditsProvider';
import { Body, Heading, Caption } from 'breeze-intelligence-kit';
import { UsageBlock } from './UsageBlock';
import { useEnrichmentPolicyNext } from '../EnrichmentPolicy/useEnrichmentPolicyNext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UsageEstimate = ({
  action,
  isLoading = false,
  numberOfOperations = 0,
  title
}) => {
  const {
    isHubspotCredits
  } = useEnrichmentCredits();
  const creditCount = getCreditCountForAction(action, numberOfOperations);
  const creditsPerRecord = getCreditCountPerAction(action);
  const {
    includedAction
  } = useEnrichmentPolicyNext();
  if (!isHubspotCredits || includedAction(action)) {
    return null;
  }
  return /*#__PURE__*/_jsxs(UsageBlock, {
    isLoading: isLoading,
    children: [/*#__PURE__*/_jsx(Heading, {
      as: "h6",
      children: title || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubSpotCredits.estimatedUsage.title"
      })
    }), /*#__PURE__*/_jsx(Body, {
      as: "p",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubSpotCredits.estimatedUsage.credits",
        options: {
          count: creditCount
        }
      })
    }), /*#__PURE__*/_jsx(Caption, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubSpotCredits.estimatedUsage.creditsPerAction",
        options: {
          count: creditsPerRecord
        }
      })
    })]
  });
};